import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  tableSection: {
    padding: '24px 0',
    '& .MuiDataGrid-overlayWrapper': {
      minHeight: '50px',
    },
    '& .MuiPagination-ul': {
      display: 'flex',
      gap: '12px',
      '& .chevron-left': {
        transform: 'rotate(-180deg)',
      },
      '& .disabled': {
        opacity: '.3',
        cursor: 'default',
      },
      '& .chevron': {
        width: '32px',
        height: '32px',
        border: '1px solid #000',
        borderRadius: '50%',
        cursor: 'pointer',
      },
      '& .currentPage': {
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
      },
    },
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '24px',
  },
  subText: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '20px',
    opacity: '0.4',
  },
  statusText: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '16px',
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: '#1D8F0B',
      '& + $track': {
        backgroundColor: 'rgba(30, 30, 30, 0.05)',
        border: '1px solid rgba(30, 30, 30, 0.05)',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid #fff',
    },
  },
  track: {
    backgroundColor: 'rgba(30, 30, 30, 0.05)',
  },
  checked: {
    backgroundColor: '#1D8F0B',
  },
  secondaryBtnWrap: {
    '& .secondary-btn': {
      background: 'none',
      border: 'none',
      padding: '0',
      color: '#1E1E1E',
      fontSize: '16px',
      fontWeight: '500',
      textDecoration: 'underline',
      textUnderlineOffset: '4px',
      cursor: 'pointer',
    },
    '& .secondary-btn:hover': { textDecoration: 'none' },
  },
  checkbox: {
    '& .MuiSvgIcon-root': {
      fontSize: 32,
    },
  },
}));
